import { Icon } from "./icons";
import moment from "moment";
import "moment-timezone";
import { FaChartPie } from "react-icons/fa";
import { providerNoteSlice } from "app/modules/ProviderNote/_redux/providerNoteSlice";
import { shallowEqual, useSelector } from "react-redux";
import { getBaseUrl } from "redux/utils";
import { cloneDeep } from "lodash";

export function parseResponse(res) {
  var response = null,
    data = null,
    meta = null,
    msg = "",
    code = -1;
  if (res.response) {
    response = res.response;
  } else if (res.data && res.data.response) {
    response = res.data.response;
  } else if (res.data && res.data.data) {
    response = res.data;
  } else if (res.isSuccess && res.data) {
    response = res;
    response.code = 0;
  }
  code = response?.code;
  msg = response?.msg || "";
  if (response?.code == 0 && response?.data) {
    data = response?.data || null;
    meta = response?.meta || null;
  }
  return { data, meta, msg, code };
}

export const compareObjects = (a, b) => {
  var equal = true;
  compareObjectsInDepth(a, b);
  function compareObjectsInDepth(a, b) {
    var keys1 = Object.keys(a);
    var keys2 = Object.keys(b);
    if (equal) {
      if (keys1.length == keys2.length) {
        keys1.forEach(function (key) {
          if (typeof a[key] == "object" && typeof b[key] == "object") {
            compareObjectsInDepth(a[key], b[key]);
          } else if (equal) {
            equal = a[key] == b[key];
          }
        });
      } else {
        equal = false;
      }
    }
  }
  return equal;
};

export const copyDeepObjects = (obj) => {
  if(obj && obj != ''){
    return JSON.parse(JSON.stringify(obj));
  }
  return null;
};

export const dataURItoFile = (dataURI, fileName) => {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  const byteString = atob(dataURI.split(",")[1]);
  // separate out the mime component
  const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

  // write the bytes of the string to an ArrayBuffer
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new File([ab], fileName, { type: mimeString });
};

export const roundToDecimals = (val, dig = 100) => {
  return Math.round(val * dig) / dig;
};

export const ceilToDecimals = (val, dig = 100) => {
  return Math.ceil(val * dig) / dig;
};

export const floorToDecimals = (val, dig = 100) => {
  return Math.floor(val * dig) / dig;
};
const isCurrentDate = (date) => {
  if (!date) return false;
    const timestamp = new Date(date).getTime();
    if (isNaN(timestamp)) return false;
    const now = new Date().getTime();
    const threeSecondsInMs = 3 * 1000;
    return Math.abs(now - timestamp) <= threeSecondsInMs;
}
export const returnPracticeDate = (date, isGetPracticeTime = false) => {

  let passedDate = cloneDeep(date);
  const { auth, selectedNote } = useSelector(
    ({ auth, providerNote }) => ({
      auth,
      selectedNote: providerNote.selectedNote,
    }),
    shallowEqual
  );


  if(isGetPracticeTime){
    return moment()?.tz(auth?.user?.practice?.timezone_long);
  }

  if (
    (!passedDate || isCurrentDate(passedDate)) && 
    selectedNote && 
    selectedNote?.encounter_data && 
    selectedNote?.encounter_data?.date) {
      passedDate = selectedNote?.encounter_data?.date;
  }

  return moment(passedDate)?.tz(auth?.user?.practice?.timezone_long);
};

export const isMatchingPracticeId = (passed_practice_id) => {

  const { practice_id } = useSelector(
    ({ auth }) => ({
      practice_id: auth.practice_id
    }),
    shallowEqual
  );

  return practice_id == passed_practice_id;
}

export function getCursorPosition(textInput) {
  var position = 0;
  if (document.selection) {
    // IE
    textInput.focus();
    var range = document.selection.createRange();
    range.moveStart("character", -textInput.value.length);
    position = range.text.length;
  } else if (textInput.selectionStart || textInput.selectionStart == "0") {
    // Other Browsers
    position = textInput.selectionStart;
  }
  return position;
}

export function removeSpecialCharacters(txt, replaceWith = '') {
  if(txt){
    return txt.replace(/[^a-z0-9]+/gi, replaceWith).toLowerCase();
  }
  return '';
}

export function waitTyping(callback) {
  let typing = true;
  setTimeout(() => {
    typing = false;
    if (!typing) {
      callback();
    }
  }, 400);
}

export const isValidNumber = value => {
  return value !== '' && !isNaN(value);
}

export function getParamString(params) {
  var paramString = "";
  if (params) {
    for (var p in params) {
      if (paramString == "") {
        paramString += "?";
      } else {
        paramString += "&";
      }
      paramString += p + "=" + params[p];
    }
  }
  return paramString;
}

export const compareDates = (from, to, diffUnit) => {
  let isBefore = true,
    diff = 0;
  if (from && to) {
    const momentFrom = moment(from);
    const momentTo = moment(to);
    isBefore = momentFrom.isSameOrBefore(momentTo);
    diff = momentTo.diff(momentFrom, diffUnit || "days");
  }
  return { isBefore, diff };
};

export const getItemClone = (item) => {
  const type = typeof item;
  if (type == "undefined" || item === null) {
    return null;
  }
  let clone;
  if (Array.isArray(item)) {
    clone = [];
    item.map((el) => {
      clone.push(getItemClone(el));
    });
  } else if (type == "object") {
    clone = {};
    Object.keys(item).map((itemKey) => {
      clone[itemKey] = getItemClone(item[itemKey]);
    });
  } else if (type == "string") {
    clone = "" + item;
  } else {
    clone = item;
  }
  return clone;
};

export const calculateFileSize = (size) => {
  var unit, pw;
  size = Number(size);
  if (size >= 1000) {
    pw = 0;
    while (size >= 1000) {
      size = size / 1000;
      pw++;
    }
    switch (pw) {
      case 1:
        unit = "KB";
        break;
      case 2:
        unit = "MB";
        break;
      case 3:
        unit = "GB";
        break;
      default:
        unit = "TB";
    }
  } else {
    unit = "bytes";
  }
  return Math.round(size * 10) / 10 + " " + unit + "-" + size;
};
export const notify = (res, dispatch) => {
  const { code, msg: serviceMsg } = parseResponse(res);
  const { actions } = providerNoteSlice;
  let type = "error",
    msg = "";
  if (res) {
    if (res.isSuccess || code == 0) {
      type = "success";
    } else {
      type = "error";
    }
    if (serviceMsg) {
      msg = serviceMsg;
    } else if (res.msg) {
      msg = res.msg;
    } else if (res.error) {
      msg = res.error.msg || "";
    } else {
      msg = res.data && res.data.msg ? res.data.msg : "";
    }
  }
  let notification = { open: true, type: type };
  if (type == "success") {
    notification.title = "Success";
    notification.msg = msg || "Done Successfully.";
  } else {
    notification.title = "Failed";
    notification.msg = msg || "Something went wrong.";
  }
  dispatch(actions.initNotificationDialog({ data: { ...notification } }));
};
export const getListItemVal = (col, item) => {
  if(col.getVal){
      return col.getVal(item);
  }
  return item[col.key] || '';
}
export const getListItemValFunc = (col, item) => {
  if (col.getVal) {
    return col.getVal(item);
  }
  return item[col.key] || "";
};
export const getYearsList = () => {
  const end = new Date().getFullYear();
  const start = 1900;
  let year,
    years = [];
  for (year = end; year >= start; year--) {
    years.push(year);
  }
  return years;
};
export const getMonthsList = () => {
  let month,
    months = [];
  for (month = 1; month <= 12; month++) {
    if (month < 10) {
      month = "0" + month;
    }
    months.push("" + month);
  }
  return months;
};
export const BtnComponent = ({
  btnType = "primary",
  type = "button",
  text = "",
  btnRef = null,
  size = "md",
  className = "",
  loading = false,
  ...btnProps
}) => {
  const defaultCss = "border rounded";
  let sizeCss = "py-1 px-2.5";
  if (size == "md") {
    sizeCss = "pr-2.5 pl-2 py-1";
  } else if (size == "sm") {
    sizeCss = "text-sm px-2 py-0.5";
  } else if (size == "xs") {
    sizeCss = "text-xs px-1 py-0.5";
  } else if (size == "tiny") {
    sizeCss = "text-xs p-0";
  }

  const typeCss = {
    // primary: 'py-1 px-2.5 font-normal border border-bgGreen rounded bg-bgGreen text-[14px] text-white hover:bg-primary-hover',
    delete:
      "py-1 px-2.5 font-normal rounded text-[14px] text-danger-hover border-danger-hover border hover:bg-danger-hover hover:text-white",
    cancel:
      "py-1 px-2.5 font-normal rounded text-[14px] text-black-300 border-gray-c3 border hover:bg-gray-e5 hover:text-black-300",
    blue: "text-white bg-blue-400 hover:bg-blue-500 dark:bg-blue-500 dark:hover:bg-blue-500 border-blue-400",
    primary:
      " font-normal border border-bgGreen rounded bg-bgGreen text-[14px] text-white hover:bg-primary-hover",
    cyan: "text-white bg-cyan-600 hover:bg-cyan-800 border-cyan-500",
    chief: "text-white bg-[#b17474] hover:bg-[#8c5c5c] border-[#b17474]",
    default: "bg-white hover:bg-gray-100 text-gray-500 border-gray-400",
    danger:
      "font-normal rounded text-[14px] text-white border-amber-600 border bg-amber-600 hover:bg-amber-700",
    success:
      "font-normal border border-bgGreen rounded bg-bgGreen text-[14px] text-white hover:bg-primary-hover",
    remove:
      "text-orange-700 bg-white hover:bg-amber-100 border-stone-300 p-0.1",
  };

  return (
    <>
      {btnType == "upload" ? (
        <div className={`${btnType == "upload" ? "relative ml-5" : "flex"}`}>
          <span className="absolute">
            <FaChartPie className="text-white my-2 mx-1" />
          </span>

          <button
            ref={btnRef}
            type={type}
            {...btnProps}
            className="inline-flex cursor-pointer justify-center rounded border border-transparent bg-teal1000 pl-6 pr-2 py-1 text-white focus:outline-none hover:bg-primary-hover"
          >
            {text}
          </button>
        </div>
      ) : (
        <button
          ref={btnRef}
          type={type}
          {...btnProps}
          className={`${
            btnProps.disabled && "opacity-50 cursor-not-allowed"
          } ${className} ${!btnProps?.noBorder && defaultCss} ${typeCss[btnType]} ${sizeCss}`}
        >
          {btnType == "remove" ? <Icon type="cross" /> : text}{" "}
          {loading ? <Icon type="inline-loader" /> : ""}
        </button>
      )}
    </>
  );
};

export const Dropdown = (props) => {
  const menuCss =
    "bg-slate-50 border border-gray-400 list-actions-menu p-1 list-actions-menu origin-top-right rounded shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none";
  const itemCss =
    "cursor-pointer hover:bg-slate-200 border border-transparent hover:text-gray-800 hover:border hover:border-slate-400";
  return (
    <div className="list-actions-link">
      <span className="cursor-pointer">
        <Icon type="bars" size="5" />
      </span>
      <div className={menuCss}>
        {props.actions.map((ac, acIndex) => {
          return (
            <span className={itemCss + (acIndex > 0 ? " ml-2" : "")}>
              <a
                className="cursor-pointer"
                onClick={() =>
                  ac.onClick(props.item, props.col, props.itemIndex)
                }
              >
                <Icon type={ac.type} />
              </a>
            </span>
          );
        })}
      </div>
    </div>
  );
};
export const formattedDate = (date, format = "MM/DD/YYYY") => {
  // "YYYY-MM-DD"
  const momentDate = moment(date).format(format);
  return moment(momentDate).isValid() ? momentDate : "";
};
export const changeTimeFormat = (time, format) => {
  //- changes time format only NOT date
  //------------ Params ------------
  //- time: hh:mm (02:44)
  //- format: required time format- moment ('hh:mm a')

  if (!format) {
    return;
  }

  let formattedTime;
  if (time.indexOf(" ") > -1) {
    formattedTime = moment(time, "hh:mm A").format(format);
  } else {
    formattedTime = moment(time, "HH:mm").format(format);
  }

  return moment(formattedTime, format).isValid() ? formattedTime : "";
};

export const isDateValid = (date, format = "MM/DD/yyyy") => {
  if (date) {
    const momentDate = moment(date);
    return momentDate.isValid() ? momentDate.format(format) : false;
  }
  return false;
};

export const trimString = (string, length, postDots = true) => {
  return string.length > length
    ? string.substring(0, length) + (postDots ? "..." : "")
    : string;
};

export const getFileUrl = (uuid) => {
  let api_url = getBaseUrl();
  let url = "";
  url += api_url + "/notes/get_attachment.json";
  url += "?uuid=" + uuid || "";
  url += "&tz=" + String(new Date().getTimezoneOffset());
  return url;
};

export const getFoxitDocumentUrl = (uuid,authToken) => {
  //https://ehr-preprod.ethizo.com/js/foxit/app/index.html?pdfDocUrl=https://api-preprod.ethizo.com/documents/view_by_uuid.json&uuid=81eedb615d474c17b13021712eb446ea&token=6590158f3b8f00951b76359349a6ca33&tz=-300&_t=1753699273112

  let api_url = getBaseUrl();
  let url = "";
  url += api_url + "/foxit/app/index.html?pdfDocUrl=";
  url += api_url + "/documents/view_by_uuid.json";
  url += "&uuid=" + uuid || "";
  url += "&token=" + authToken || "";
  url += "&tz=" + String(new Date().getTimezoneOffset());
  return url;
};

export const loadDocumentAttachment=(uuid,authToken)=>{
  //https://api-preprod10x.ethizo.com/documents/view_by_uuid.json?uuid=c0ade019fa954f76a6d6ae55a8ec3175&token=6590158f3b8f00951b76359349a6ca33&tz=-300
  let api_url = getBaseUrl();
  let url = "";
  url += api_url + "/documents/view_by_uuid.json";
  url += "?uuid=" + uuid || "";
  url += "&token=" + authToken || "";
  url += "&tz=" + String(new Date().getTimezoneOffset());
  return url;
}




export const printPdfDoc = (url) => {
  let w = window.open("", "Print");
  w.document.write("<html><head>");
  w.document.write("</head><body >");
  w.document.write(
    `<img id="print-image-element" src="${url}" style="object-fit: cover; max-height: 100%; max-width:100%;" />`
  );
  w.document.write(
    '<script>var img = document.getElementById("print-image-element"); img.addEventListener("load",function(){ console.log("image loaded!"); window.focus(); window.print(); window.document.close(); window.close(); }); </script>'
  );
  w.document.write("</body></html>");
};

export const formatAmount = (amount, skipSymbol) => {
  if (isNaN(amount)) {
    return "";
  }
  const symbol = skipSymbol ? "" : "$";
  return symbol + new Intl.NumberFormat("en-IN").format(amount);
};

export const getDataObjects = (data = {}, objKeys = [], dir = "get") => {
  const fn = {
    get: (key) => {
      if (data[key]) {
        data[key + "_obj"] = {
          id: data[key],
          name: data[key + "_name"] || "",
        };
      }
    },
    post: (key) => {
      const userObj = data[key + "_obj"];
      if (userObj) {
        data[key] = userObj.id;
        data[key + "_name"] = userObj.name;
      }
    },
  };
  objKeys.map((key) => {
    fn[dir](key);
  });
};

export const renderLineBreaks = txt => {
    return txt.replace(/\n/g, "<br />");
}
export const getTimeList = (max=76, num=false) => {
  let acpTimeArr = [];
  let i;
  for(i = 0; i < max; i++){
    if(num){
      acpTimeArr.push(i);
    }else{
      acpTimeArr.push({option_id: i, label: i});
    }
  }
  return acpTimeArr;
}
export const useGetGlobalAttributes = () => {
  const { authToken, practiceId, selectedNote } = useSelector(
    ({ providerNote, auth }) => ({
      authToken: auth && auth.authToken,
      practiceId: auth?.practice_id,
      selectedNote: providerNote.selectedNote,
    }),
    shallowEqual
  );
  const tz = new Date().getTimezoneOffset();
  const { baseUrl } = { baseUrl: process.env.REACT_APP_API_URL_V1 };
  return {authToken, practiceId, tz, selectedNote, baseUrl};
}
export const formatProcedureKeyIndex = (keyIndex) => {
    keyIndex = keyIndex?.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
    if (keyIndex?.startsWith('Is ')) {
        keyIndex = keyIndex?.replace('Is ', '');
    }
    return keyIndex;
};

export const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export const ProcedureOrderHTML = ({ procedureOrder, prcdrItem, authToken, practiceId, baseUrl, callback }) => {

  if (!procedureOrder?.procedure_items?.length) {
      return null;
  }

  // Extract general details from procedureOrder
  const {
      order_datetime,
      order_number,
      order_provider_name,
      location_name,
      is_billable,
      has_result,
      status,
      reviewed,
      acknowledged
  } = procedureOrder;

  const OrderDate = moment(order_datetime).format("MM/DD/YYYY");
  const OrderNum = order_number;
  const OrderProvider = order_provider_name;
  const Location = location_name;
  const IsBillable = is_billable ? 'Yes' : 'No';
  const OrderStatus = !has_result ? status : '';
  const isReviewed = has_result && reviewed ? 'Yes' : '';
  const isAcknowledged = has_result && acknowledged ? 'Yes' : '';

  const procedureItems = prcdrItem && prcdrItem?.id ? procedureOrder.procedure_items?.filter(item => item?.id === prcdrItem?.id) : procedureOrder.procedure_items;

  return (
      <div>
          <ul style={{listStyle: 'none', padding: 0, display: 'flex', flexWrap: 'wrap', gap: '2px', marginBottom: '0px'}}>
              <li style={{flex: '1 1 calc(25% - 10px)', padding: '5px', border: '1px solid #ddd', borderRadius: '3px'}}><b>Order Date:</b><br/>{OrderDate}</li>
              <li style={{flex: '1 1 calc(25% - 10px)', padding: '5px', border: '1px solid #ddd', borderRadius: '3px'}}><b>Order Number:</b><br/>{OrderNum}</li>
              <li style={{flex: '1 1 calc(25% - 10px)', padding: '5px', border: '1px solid #ddd', borderRadius: '3px'}}><b>Order Provider:</b><br/>{OrderProvider}</li>
              <li style={{flex: '1 1 calc(25% - 10px)', padding: '5px', border: '1px solid #ddd', borderRadius: '3px'}}><b>Location:</b><br/>{Location}</li>
              <li style={{flex: '1 1 calc(25% - 10px)', padding: '5px', border: '1px solid #ddd', borderRadius: '3px'}}><b>Is Billable:</b><br/>{IsBillable}</li>
              {OrderStatus && <li style={{flex: '1 1 calc(25% - 10px)', padding: '5px', border: '1px solid #ddd', borderRadius: '3px'}}><b>Order Status:</b><br/>{capitalize(OrderStatus)}</li>}
              {isReviewed && <li style={{flex: '1 1 calc(25% - 10px)', padding: '5px', border: '1px solid #ddd', borderRadius: '3px'}}><b>Reviewed:</b><br/>{isReviewed}</li>}
              {isAcknowledged && <li style={{flex: '1 1 calc(25% - 10px)', padding: '5px', border: '1px solid #ddd', borderRadius: '3px'}}><b>Acknowledged:</b><br/>{isAcknowledged}</li>}
          </ul>

          {procedureItems?.map((procedureItem) => {
              const {
                  status,
                  performed_on,
                  refusal,
                  cpt_code,
                  cpt_desc_short,
                  performed_by_name,
                  urgency,
                  modifier_objects,
                  form_data,
                  patient_instructions,
                  files = []
              } = procedureItem;

              const performedOn = status !== 'refused' && performed_on ? moment(performed_on).format("MM/DD/YYYY") : '';
              const recordedDate = status === 'refused' && refusal?.recorded_date ? moment(refusal.recorded_date).format("MM/DD/YYYY") : '';
              const Code = `${cpt_code} - ${cpt_desc_short}`;
              const performedBy = status !== 'refused' && performed_by_name || '';
              const refusedBy = status === 'refused' && refusal?.recorded_by_name || '';
              const resusalReason = status === 'refused' && refusal?.refusal_reason || '';
              const modifiers = modifier_objects?.length ? modifier_objects.map(mod => `${mod.option_id} - ${mod.title}`).join(', ') : '';
              const procedureStatus = status || '';

              let procedureDX1 = "";
              if (form_data?.dx1) {
                  const { label, code, name } = form_data.dx1;
                  if (label) {
                      procedureDX1 = label;
                  } else if (code) {
                      procedureDX1 = `${code} - ${name}`;
                  }
              }

              let procedureDX2 = "";
              if (form_data?.dx2) {
                  const { label, code, name } = form_data.dx2;
                  if (label) {
                      procedureDX2 = label;
                  } else if (code) {
                      procedureDX2 = `${code} - ${name}`;
                  }
              }

              const procedureDetails = form_data?.procedure_details || '';
              const procedureInstructions = patient_instructions || '';
              const procedureFindings = form_data?.finding || '';
              
              const procedureFollowUp = form_data?.followup?.patient_tolerated_procedure !== "no" ? 
                  "Patient tolerated the procedure" : form_data?.followup?.patient_not_tolerated_procedure_reason || '';
                  
              const preProcedureMeds = form_data?.pre_procedure_meds?.map(med => med.DrugDescription).join(', ') || '';

              const preProcCareArr = [];

              if (form_data?.pre_procedure?.consent) {
                  const { consent } = form_data.pre_procedure;

                  if (consent.is_consent_required === 'no') {
                      preProcCareArr.push("Consent was not taken as it was not required for this procedure");
                  } else {
                      if (consent.is_consent_obtained === 'no') {
                          const consentReason = consent.consent_not_obtained_reason?.toLowerCase() === 'other'
                              ? consent.consent_not_obtained_other_reason 
                              : consent.consent_not_obtained_reason;

                          let consentNotTaken = "Consent was not taken";
                          if (consentReason) {
                              consentNotTaken += ` because "${consentReason}"`;
                          }
                          preProcCareArr.push(consentNotTaken);
                      } else if (consent.is_consent_obtained) {
                          preProcCareArr.push("Consent was taken");
                      }
                  }
              }

              if (form_data?.pre_procedure) {
                  const { 
                      is_risks_explained,
                      is_questions_answered,
                      is_patient_identified,
                      is_side_and_site_confirmed
                  } = form_data?.pre_procedure;

                  if (is_risks_explained) preProcCareArr.push("Procedure/risks were explained");
                  if (is_questions_answered) preProcCareArr.push("Questions were answered");
                  if (is_patient_identified) preProcCareArr.push("Correct patient was identified");
                  if (is_side_and_site_confirmed) preProcCareArr.push("Correct side and site was confirmed");
              }

              const preProcedureCare = preProcCareArr.join(', ');

              return (
                  <div key={procedureItem.id} style={{borderBottom: '1px solid #f0f0f0', marginBottom: '5px'}}>
                      <div style={{padding: '5px 0px 0px 0px'}}>
                          <div style={{boxShadow: '2px 2px 10px rgba(0, 0, 0, 0.1)', background: '#f9f9f9'}}>
                              <ul style={{listStyle: 'none', padding: 0, display: 'flex', flexWrap: 'wrap', gap: '2px'}}>
                                  {Code && (
                                      <li style={{flex: '1 1 calc(100%)', padding: '5px', border: '1px solid #ddd', borderRadius: '3px', fontWeight: 'bold', position: 'relative'}}>
                                          {Code}
                                          {procedureItem.status === 'performed' && callback && (
                                              <a title='Add Review' onClick={() => callback(procedureOrder, procedureItem)} className='text-blue-600 visited:text-blue-900 font-normal' style={{position: 'absolute', right: '5px', cursor: 'pointer'}}>
                                                  Add Review
                                              </a>
                                          )}
                                      </li>
                                  )}
                                  {urgency && <li style={{flex: '1 1 calc(25% - 10px)', padding: '5px', border: '1px solid #ddd', borderRadius: '3px'}}><b>Urgency:</b><br/>{capitalize(urgency)}</li>}
                                  {procedureStatus && <li style={{flex: '1 1 calc(25% - 10px)', padding: '5px', border: '1px solid #ddd', borderRadius: '3px'}}><b>Status:</b><br/>{capitalize(procedureStatus)}</li>}
                                  {performedOn && <li style={{flex: '1 1 calc(25% - 10px)', padding: '5px', border: '1px solid #ddd', borderRadius: '3px'}}><b>Performed On:</b><br/>{performedOn}</li>}
                                  {performedBy && <li style={{flex: '1 1 calc(25% - 10px)', padding: '5px', border: '1px solid #ddd', borderRadius: '3px'}}><b>Performed By:</b><br/>{performedBy}</li>}
                                  {recordedDate && <li style={{flex: '1 1 calc(25% - 10px)', padding: '5px', border: '1px solid #ddd', borderRadius: '3px'}}><b>Recorded Date:</b><br/>{recordedDate}</li>}
                                  {refusedBy && <li style={{flex: '1 1 calc(25% - 10px)', padding: '5px', border: '1px solid #ddd', borderRadius: '3px'}}><b>Refused By:</b><br/>{refusedBy}</li>}
                                  {resusalReason && <li style={{flex: '1 1 calc(25% - 10px)', padding: '5px', border: '1px solid #ddd', borderRadius: '3px'}}><b>Refusal Reason:</b><br/>{resusalReason}</li>}
                                  {modifiers && <li style={{flex: '1 1 calc(25% - 10px)', padding: '5px', border: '1px solid #ddd', borderRadius: '3px'}}><b>Modifiers:</b><br/>{modifiers}</li>}
                                  {procedureDX1 && <li style={{flex: '1 1 calc(25% - 10px)', padding: '5px', border: '1px solid #ddd', borderRadius: '3px'}}><b>DX1:</b><br/>{procedureDX1}</li>}
                                  {procedureDX2 && <li style={{flex: '1 1 calc(25% - 10px)', padding: '5px', border: '1px solid #ddd', borderRadius: '3px'}}><b>DX2:</b><br/>{procedureDX2}</li>}
                                  {procedureFollowUp && <li className="break-words whitespace-pre-wrap" style={{flex: '1 1 calc(25% - 10px)', padding: '5px', border: '1px solid #ddd', borderRadius: '3px'}}><b>Follow-up & Patient Response:</b><br/>{procedureFollowUp}</li>}
                                  {preProcedureMeds && <li className="break-words whitespace-pre-wrap" style={{flex: '1 1 calc(25% - 10px)', padding: '5px', border: '1px solid #ddd', borderRadius: '3px'}}><b>Pre-Procedure Medications:</b><br/>{preProcedureMeds}</li>}
                                  {preProcedureCare && <li className="break-words whitespace-pre-wrap" style={{flex: '1 1 calc(25% - 10px)', padding: '5px', border: '1px solid #ddd', borderRadius: '3px'}}><b>Pre-Procedure Care:</b><br/>{preProcedureCare}</li>}
                                  {procedureDetails && <li className="break-words whitespace-pre-wrap" style={{flex: '1 1 calc(100%)', padding: '5px', border: '1px solid #ddd', borderRadius: '3px'}}><b>Procedure Details:</b><br/>{procedureDetails}</li>}
                                  {procedureInstructions && <li className="break-words whitespace-pre-wrap" style={{flex: '1 1 calc(100%)', padding: '5px', border: '1px solid #ddd', borderRadius: '3px'}}><b>Procedure Instructions:</b><br/>{procedureInstructions}</li>}
                                  {procedureFindings && <li className="break-words whitespace-pre-wrap" style={{flex: '1 1 calc(100%)', padding: '5px', border: '1px solid #ddd', borderRadius: '3px'}}><b>Findings:</b><br/>{procedureFindings}</li>}
                                  {files.length > 0 && (
                                      <li style={{flex: '1 1 calc(100%)', padding: '5px', border: '1px solid #ddd', borderRadius: '3px'}}>
                                          <b style={{display: 'inline-block', marginBottom: '5px'}}>Attachments:</b><br/>
                                          {files.map((file, fileIndex) => {
                                              const fileID = file.file_id || file.uuid || '';
                                              const fileTitle = file.file_title || file.title || 'Attachment';
                                              const tz = new Date().getTimezoneOffset();
                                              const url = `${baseUrl}/messages/read_attachment.json?uuid=${fileID}&token=${authToken}&practice_id=${practiceId}&tz=${tz}`;
                                              return fileID ? (<>
                                                <a key={fileID} className='text-blue-600 visited:text-blue-900' href={url} target='_blank' rel="noreferrer">
                                                      {fileTitle}
                                                  </a>
                                                  {fileIndex < files.length - 1 && <span className='mr-1'>, </span>}
                                              </>) : null;
                                          })}
                                      </li>
                                  )}
                              </ul>
                          </div>
                      </div>
                  </div>
              );
          })}
      </div>
  );
};